import React from 'react';
import EmployeeAssessments from '../../components/competency-matrix/EmployeeAssessments';

const MyAssessmentsPage = () => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-sm">
      <EmployeeAssessments />
    </div>
  );
};

export default MyAssessmentsPage;
